import { useEffect, useState } from "react";
import { TestimonialCarousel } from "@/sanity/sanity.types";
import css from "./home-reviews.module.scss";
import HomeReviewCard from "../home-review-card/home-review-card";
import HomeVideoCard from "../home-video-card/home-video-card";
import GridRow from "@/components/common/grid-row/grid-row";
import GridColumn from "@/components/common/grid-column/grid-column";
import Carousel from "@/components/common/carousel/carousel";
import HomeStats from "../home-stats/home-stats";
interface IHomeReviewsProps {
  data: TestimonialCarousel;
  showStats?: boolean;
  quoteShow?: boolean;
}
const HomeReviews = (props: IHomeReviewsProps) => {
  const {
    data,
    showStats = true,
    quoteShow = false
  } = props;
  const {
    heading,
    items,
    subhead
  } = data;
  const quoteItems = items?.filter(item => item._type === "testimonialQuoteItem") ?? [];
  const videoItems = items?.filter(item_0 => item_0._type === "testimonialVideoItem") ?? [];
  const groupItems = (items_0: any[]) => {
    const groupedItems: any[] = [];
    for (let i = 0; i < items_0.length; i += 3) {
      groupedItems.push(items_0.slice(i, i + 3));
    }
    return groupedItems;
  };
  const formatHighlight = (text: string) => {
    const keyword = "You Can Trust";
    if (isSmall && text.includes(keyword)) {
      const [before] = text.split(keyword);
      return <>
          {before}
          <br />
          {keyword}
        </>;
    }
    return text;
  };
  function useIsSmallScreen(maxWidth = 640) {
    const [isSmall_0, setIsSmall] = useState(false);
    useEffect(() => {
      const checkScreen = () => {
        setIsSmall(window.innerWidth <= maxWidth);
      };
      checkScreen();
      window.addEventListener("resize", checkScreen);
      return () => window.removeEventListener("resize", checkScreen);
    }, [maxWidth]);
    return isSmall_0;
  }
  const isSmall = useIsSmallScreen(640);
  return <div className={css.homeReviews}>
      <GridRow className="!gap-y-6">
        <GridColumn className="flex flex-col gap-2">
          {heading && <h2 className={`${quoteShow ? "lg:text-center" : "text-center"}`}>
              {formatHighlight(heading)}{" "}
            </h2>}
          {subhead && <p className={`${quoteShow ? "lg:text-center" : "text-center"}`}>
              {subhead}
            </p>}
        </GridColumn>
        {showStats && <HomeStats />}
        {videoItems.length > 0 && <GridColumn className={showStats ? "md:mt-24" : ""}>
            <Carousel itemsPerPage={3} className="!hidden md:!flex">
              {videoItems.map((item_1, index) => <HomeVideoCard key={index} data={item_1} />)}
            </Carousel>
            <Carousel itemsPerPage={1} className="mt-9 !flex md:!hidden">
              {groupItems(videoItems).map((group, groupIndex) => {
            return <div key={groupIndex} className="flex flex-col gap-[16px]">
                    {group.map((item_2: any, itemIndex: number) => <HomeVideoCard key={`${groupIndex}-${itemIndex}`} data={item_2} />)}
                  </div>;
          })}
            </Carousel>
          </GridColumn>}
      </GridRow>
      {quoteItems.length > 0 && !quoteShow && <GridRow className="!mt-14">
          <GridColumn>
            <div className="hidden md:block">
              <Carousel itemsPerPage={3} interval={3000}>
                {quoteItems.map((item_3, index_0) => <HomeReviewCard key={index_0} data={item_3} />)}
              </Carousel>
            </div>
            <div className="block md:hidden">
              <Carousel itemsPerPage={1} interval={3000}>
                {quoteItems.map((item_4, index_1) => <HomeReviewCard key={index_1} data={item_4} />)}
              </Carousel>
            </div>
          </GridColumn>
        </GridRow>}
    </div>;
};
export default HomeReviews;